import { render, staticRenderFns } from "./ConfirmDeleteAccountModal.vue?vue&type=template&id=11c77934&scoped=true"
import script from "./ConfirmDeleteAccountModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c77934",
  null
  
)

export default component.exports